var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalendar = function SvgCalendar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "1031 168 17.12 17.12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .calendar-1 {\n        fill: none;\n      }\n\n      .calendar-3 {\n        clip-path: url(#clip-path);\n      }\n\n      .calendar-4 {\n        clip-path: url(#clip-path-2);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8436",
    "data-name": "Path 8436",
    className: "calendar-1",
    d: "M5.11,0h0a.44.44,0,0,1,.44.44v3a.44.44,0,0,1-.44.44h0a.44.44,0,0,1-.44-.44v-3A.44.44,0,0,1,5.11,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8438",
    "data-name": "Path 8438",
    className: "calendar-1",
    d: "M12.12,0h0a.44.44,0,0,1,.44.44v3a.44.44,0,0,1-.44.44h0a.44.44,0,0,1-.44-.44v-3A.44.44,0,0,1,12.12,0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar_icon",
    "data-name": "calendar icon",
    transform: "translate(1031 168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1516",
    "data-name": "Rectangle 1516"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7838",
    "data-name": "Rectangle 7838",
    className: "calendar-1",
    width: 17.12,
    height: 15.56,
    rx: 2,
    transform: "translate(0 1.56)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8434",
    "data-name": "Path 8434",
    className: "calendar-2",
    d: "M15.12,17.12H2a2,2,0,0,1-2-2V3.56a2,2,0,0,1,2-2H15.12a2,2,0,0,1,2,2V15.12a2,2,0,0,1-2,2ZM2,2.56a1,1,0,0,0-1,1V15.12a1,1,0,0,0,1,1H15.12a1,1,0,0,0,1-1V3.56a1,1,0,0,0-1-1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1351",
    "data-name": "Path 1351"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7839",
    "data-name": "Rectangle 7839",
    className: "calendar-2",
    width: 16.47,
    height: 1,
    transform: "translate(0.65 6.91)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1517",
    "data-name": "Rectangle 1517"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8435",
    "data-name": "Path 8435",
    className: "calendar-2",
    d: "M5.11,0h0a.44.44,0,0,1,.44.44v3a.44.44,0,0,1-.44.44h0a.44.44,0,0,1-.44-.44v-3A.44.44,0,0,1,5.11,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13082",
    "data-name": "Group 13082",
    className: "calendar-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7840",
    "data-name": "Rectangle 7840",
    className: "calendar-2",
    width: 1.11,
    height: 3.89,
    transform: "translate(4.56)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1518",
    "data-name": "Rectangle 1518"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fill-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8437",
    "data-name": "Path 8437",
    className: "calendar-2",
    d: "M12.12,0h0a.44.44,0,0,1,.44.44v3a.44.44,0,0,1-.44.44h0a.44.44,0,0,1-.44-.44v-3A.44.44,0,0,1,12.12,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13083",
    "data-name": "Group 13083",
    className: "calendar-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7841",
    "data-name": "Rectangle 7841",
    className: "calendar-2",
    width: 1.11,
    height: 3.89,
    transform: "translate(11.56)"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalendar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calendar.3c51f5a1.svg";
export { ForwardRef as ReactComponent };